import { createI18n } from 'vue-i18n';

const messages = {};

const context = require.context('@js/i18n/messages', true, /\.js$/);
let path, lang, namespace;
context.keys().map(key => {
    path = key.split('/');

    lang = path[1];
    namespace = path[2].split('.')[0];
    if (!messages[lang]) messages[lang] = {};
    if (!messages[lang][namespace]) messages[lang][namespace] = {};
    messages[lang][namespace] = context(key);
});

// Retourne la langue à utiliser en se basant sur celle du navigateur
const getLangToUsed = (() => {
    const defaultLang = 'fr';
    try {
        const navigatorLang = (navigator.language ?? defaultLang);

        const lang = navigatorLang.split('-').at(0);

        const allowedLang = [ 'fr', 'en' ];
        if(allowedLang.indexOf(lang) === -1) {
            return defaultLang;
        }

        return lang;

    } catch(e) {
        return defaultLang;
    }
});

const i18n = createI18n({
    locale: getLangToUsed(),
    fallbackLocale: 'fr',
    messages,
    silentTranslationWarn: true,
    warnHtmlMessage: false,
    legacy: false
});

export default i18n;
